// New UI_REVAMP
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import failedGif from '../assets/gif/failed.gif';
import ribbonGif from '../assets/gif/ribbon.gif';
import BetDetailsCard from '../components/bet-result/BetDetailsCard';
import GoldPatternButton from '../components/button/GoldPatternButton';
import { useBettingScreen } from '../hooks/useStore';
import betSuccessful from '../lottie/betSuccessful.json';

const STATUS_CONFIG = {
	success: {
		title: 'Bet Successful',
		icon: { type: 'lottie', data: betSuccessful },
		bgGradient: 'radial-gradient(70% 60% at 50% 50%, #D6BBFF 40%, #8555FD 100%)',
		boxShadow: `0px 4px 50px rgba(15, 32, 82, 0.25), 
                    inset 0px -2px 5px rgba(255,255,255,0.4), 
                    inset 0px -10px 30px rgba(108,121,220,0.7)`,
		overlayBg: 'rgba(206, 201, 239, 0.8)',
		buttonText: 'View Ticket',
		titleColor: 'white',
	},
	failed: {
		title: 'Bet Failed',
		icon: { type: 'image', data: failedGif },
		bgGradient: 'radial-gradient(70% 60% at 50% 50%, #FE91AA 40%, #D60F65 100%)',
		boxShadow: `0px 4px 50px 0px #E9119D40, 
                    inset 0px -2px 5px 0px #FFFFFF66, 
                    inset 0px -6px 25px 0px #EC0A5DB2`,
		overlayBg: '#F18FB099',
		buttonText: 'Back to Home',
		titleColor: 'white',
	},
};

const BackgroundDecoration = ({ config, children }) => (
	<Box position='relative' w='100%' h='100%'>
		<Box
			position='absolute'
			top='-25%'
			left='50%'
			transform='translateX(-50%)'
			w='160%'
			h='90%'
			borderRadius='50%'
			bg={config.overlayBg}
			zIndex={1}
		/>
		<Box
			position='absolute'
			top='-35%'
			left='50%'
			transform='translateX(-50%)'
			w='160%'
			h='90%'
			borderRadius='50%'
			bg={config.bgGradient}
			sx={{ backdropFilter: 'blur(8px)' }}
			boxShadow={config.boxShadow}
			zIndex={2}
		/>
		{children}
	</Box>
);

const ResultHeader = ({ status, amount, config }) => {
	const isSuccess = status === 'success';
	return (
		<Flex position='absolute' top={0} zIndex={3} flexDirection='column' w='100%' gap={12}>
			{config.icon.type === 'lottie' ? (
				<Lottie
					animationData={config.icon.data}
					loop
					renderer='svg'
					style={{ width: '240px', alignSelf: 'center' }}
				/>
			) : (
				<Image src={config.icon.data} alt='failed' mx='auto' w='150px' h='150px' mt={20} />
			)}

			<Box mt={isSuccess ? -20 : -14} textAlign='center'>
				<Text fontWeight='500' fontSize='24px' color={config.titleColor} mt={!isSuccess ? 6 : 0}>
					{config.title}
				</Text>

				{isSuccess ? (
					<Text fontWeight='800' fontSize='36px' color='white'>
						PHP {amount}
					</Text>
				) : (
					<Text fontWeight='500' fontSize='16px' color='white'>
						Please try again later
					</Text>
				)}
			</Box>
		</Flex>
	);
};

export const MobileBetResultScreen = ({ downloadId = 'bet-result-ticket' }) => {
	const results = useBettingScreen((state) => state.results);
	const navigate = useNavigate();

	const hasFailedBet = results?.betting?.some((bet) => bet.isFail);
	const statusVal = hasFailedBet ? 'failed' : results?.status?.toLowerCase() || 'success';
	const config = STATUS_CONFIG[statusVal] || STATUS_CONFIG.success;
	const isSuccess = statusVal === 'success';
	const amount = isSuccess ? results?.totalSuccessPrice : undefined;

	return (
		<Flex
			w='100%'
			h='full'
			position='relative'
			overflow='hidden'
			display={{ base: 'flex', lg: 'none' }}
			justify='center'
			align='flex-start'
			bg='#eeeeee'
		>
			<BackgroundDecoration config={config}>
				<ResultHeader config={config} status={statusVal} amount={amount} />
			</BackgroundDecoration>

			<Image
				src={ribbonGif}
				alt='Ribbon gif'
				position='absolute'
				top={0}
				left={0}
				w='100%'
				h='100%'
			/>

			<Box position='absolute' bottom={8} left={4} right={4} zIndex={3}>
				{isSuccess && <BetDetailsCard data={results} downloadId={downloadId} />}

				<GoldPatternButton
					onClick={() => {
						if (isSuccess) {
							sessionStorage.setItem('accessTicketId', results?.ticketId);
							navigate('/history/ticketdetail');
						} else {
							navigate('/');
						}
					}}
				>
					{config.buttonText}
				</GoldPatternButton>
			</Box>
		</Flex>
	);
};
